<template>
   <div class="record-alu-fullscreen">
      <v-snackbar
         v-model="snackbar"
         :color="snackColor"
         :right="true"
         :bottom="true"
         :timeout="4000"
      >
         {{ snackText }}
         <template #action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
         </template>
      </v-snackbar>

      <v-dialog v-model="dialogReporteLoading" persistent width="300">
         <v-card color="primary" dark class="pt-5 pb-2">
            <v-card-text style="color: white">
               Consultando notas en base de datos web de Registro Académico
               <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
         </v-card>
      </v-dialog>

      <!-- Barra de búsqueda -->
      <div class="record-search-bar">
         <div style="width:220px">
            <v-select
               v-model="selectCiclo"
               :items="cmbCiclo"
               color="primary"
               label="Ciclo"
               placeholder="Seleccionar..."
               dense
               hide-details
               readonly
            ></v-select>
         </div>
         <div style="width:260px">
            <v-text-field
               v-model="carnetLocal"
               v-mask="'####-AA-###'"
               append-icon="fa-search"
               color="primary"
               label="Carnet"
               dense
               hide-details
            ></v-text-field>
         </div>
         <v-btn color="primary" depressed @click="listarHistorico()">
            <v-icon left small>fas fa-search</v-icon>Buscar
         </v-btn>
      </div>

      <!-- Tabla de notas (ocupa el espacio disponible) -->
      <div class="record-table-area">
         <v-data-table
            v-if="verNuevo == 0"
            :headers="headers"
            :items="notas"
            :search="search"
            :hide-default-footer="true"
            dense
            class="elevation-1 record-datatable"
         >
            <template slot="no-data">
               <div v-if="notas.length == 0">
                  <v-btn color="primary" @click="reset">Sin notas para el ciclo</v-btn>
               </div>
            </template>
            <template #item.promedio="{ item }">{{ getProm(item) }}</template>
            <template #item.asistencia="{ item }">{{ item.asistencia + '%' }}</template>
         </v-data-table>
      </div>

      <!-- Resumen académico (fijo abajo) -->
      <div class="record-resumen-area">
         <v-simple-table dense>
            <template #default>
               <thead>
                  <tr>
                     <th class="text-left">Aprobadas Carrera</th>
                     <th class="text-left">Reprobadas Carrera</th>
                     <th class="text-left">Aprobadas Total</th>
                     <th class="text-left">Reprobadas Total</th>
                     <th class="text-left">Promedio</th>
                     <th class="text-left">CUM</th>
                  </tr>
               </thead>
               <tbody>
                  <tr v-for="item in resumen" :key="item.cum" class="resumen-row-clickable" @click="dialogResumen = true">
                     <td>{{ item.aprobadasCarrera }}</td>
                     <td>{{ item.reprobadasCarrera }}</td>
                     <td>{{ item.aprobadasTotal }}</td>
                     <td>{{ item.reprobadasTotal }}</td>
                     <td>{{ item.promedio }}</td>
                     <td>{{ item.cum }}</td>
                  </tr>
               </tbody>
            </template>
         </v-simple-table>
      </div>

      <!-- Dialog resumen en grande -->
      <v-dialog v-model="dialogResumen" max-width="640px">
         <v-card class="resumen-dialog-card">
            <v-card-title class="resumen-dialog-title primary white--text">
               Resumen académico
               <v-spacer></v-spacer>
               <v-btn icon dark small @click="dialogResumen = false"><v-icon small>fas fa-times</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-5 pb-4 px-5">
               <div v-for="item in resumen" :key="item.cum" class="resumen-big-grid">
                  <div class="resumen-big-stat resumen-stat--green">
                     <div class="rbs-value">{{ item.aprobadasCarrera }}</div>
                     <div class="rbs-label">Aprobadas Carrera</div>
                  </div>
                  <div class="resumen-big-stat resumen-stat--red">
                     <div class="rbs-value">{{ item.reprobadasCarrera }}</div>
                     <div class="rbs-label">Reprobadas Carrera</div>
                  </div>
                  <div class="resumen-big-stat resumen-stat--green">
                     <div class="rbs-value">{{ item.aprobadasTotal }}</div>
                     <div class="rbs-label">Aprobadas Total</div>
                  </div>
                  <div class="resumen-big-stat resumen-stat--red">
                     <div class="rbs-value">{{ item.reprobadasTotal }}</div>
                     <div class="rbs-label">Reprobadas Total</div>
                  </div>
                  <div class="resumen-big-stat resumen-stat--blue">
                     <div class="rbs-value">{{ item.promedio }}</div>
                     <div class="rbs-label">Promedio</div>
                  </div>
                  <div class="resumen-big-stat resumen-stat--primary">
                     <div class="rbs-value">{{ item.cum }}</div>
                     <div class="rbs-label">CUM</div>
                  </div>
               </div>
            </v-card-text>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import axios from 'axios'
import formatters from '../mixins/formattersLib'
import { mask } from 'vue-the-mask'

export default {
   name: 'RecordAlu',
   directives: {
      mask
   },
   components: {},
   mixins: [formatters],
   props: {
      carnet: {
         type: String,
         default: ''
      },
      showDialog: {
         type: Boolean,
         default: false
      },
      all: {
         type: Boolean,
         default: true
      }
   },
   data: (vm) => ({
      // Variables
      dialogEditar: false,
      editedIndex: -1,
      headers: [
         {
            text: 'Código',
            value: 'materiaCodigo',
            width: 100,
            class: 'titulo'
         },
         {
            text: 'Materia',
            value: 'materia',
            width: 250,
            class: 'titulo'
         },
         {
            text: 'Sección',
            value: 'seccion',
            width: 120,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Nota I',
            value: 'periodoA',
            width: 100,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Asistencia I',
            value: 'asistenciaA',
            width: 150,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Nota II',
            value: 'periodoB',
            width: 100,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Asistencia II',
            value: 'asistenciaB',
            width: 150,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Nota III',
            value: 'periodoC',
            width: 100,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Asitencia III',
            value: 'asistenciaC',
            width: 150,
            align: 'center',
            class: 'titulo'
         },
         {
            text: 'Promedio',
            value: 'promedio',
            width: 120,
            align: 'center',
            class: 'titulo'
         }
      ],
      // Variables de formularios
      dialogReporteLoading: false,
      btnDetalleColor: 'primary white--text',
      talonario: [],
      talonarios: [],
      notas: [],
      detalleIcon: 'fa-plus',
      fecha: vm.toISOLocal(new Date()).substr(0, 10),
      radiosBusqueda: 'r-npe',
      search: '',
      // Variables detalles de talonario
      // Otros
      read: 0,
      result: [],
      snackColor: 'primary',
      snackbar: false,
      valida: 0,
      verNuevo: 0,
      snackText: '',
      dialogPrint: false,
      // ciclos
      selectCiclo: '',
      cmbCiclo: [],
      resumen: [],
      carnetLocal: '',
      dialogResumen: false

      // Reglas de validacion de formularios marti
   }),
   computed: {},
   watch: {
      carnet(val) {
         this.carnetLocal = val
      },
      showDialog(val) {
         if (val) {
            this.notas = []
            this.talonarios = []
            this.carnetLocal = this.carnet
            setTimeout(() => {
               this.listarHistorico()
            }, 500)
         }
      }
   },
   created() {
      this.listarComboBoxes()
   },
   mounted() {
      window.addEventListener('resize', this.ajustarAltura)
      this.$nextTick(this.ajustarAltura)
   },
   beforeDestroy() {
      window.removeEventListener('resize', this.ajustarAltura)
   },
   methods: {
      focusBusqueda() {
         this.$refs.txtBusqueda.focus()
      },
      // Si no cargaron bien las talonarios en el datatable vuelve a listar
      reset() {
         this.listarComboBoxes()
      },
      // ------------------ LISTAR INFORMACION --------------------
      /* Metodos para listar informacion desde la API */

      // Listar las talonarios de un periodo y popula el datatable principal
      listarHistorico() {
         this.notas = []
         this.talonarios = []
         this.dialogReporteLoading = true
         //console.log(me.dialogReporteLoading)
         axios
            .get('api/AlumnoNotas?Carnet=' + this.carnetLocal)
            .then((response) => {
               this.notas = response.data
               axios
                  .get(
                     'api/SolicitudDeBeca/AlumnoResumenAcademico?Carnet=' +
                        this.carnetLocal
                  )
                  .then((response) => {
                     this.resumen = response.data
                  })
                  .catch((error) => {
                     console.log(error)
                  })
               this.dialogReporteLoading = false
            })
            .catch((error) => {
               console.log(error)
               this.dialogReporteLoading = false
            })
         axios
            .get(
               'api/Contrato/Cuotas?Carnet=' +
                  this.carnetLocal +
                  '&PeriodoLectivo=' +
                  this.selectCiclo
            )
            .then((response) => {
               this.talonarios = response.data.sort(this.dynamicSort('cuota'))
            })
            .catch((error) => {
               console.log(error)
            })
      },
      printTalonario() {
         this.dialogPrint = true
         //me.editarTalonario(item, true)
      },
      closeDialogPrint() {
         this.dialogPrint = false
         this.clear()
      },
      listarComboBoxes() {
         axios
            .get('api/Configuracion/cicloActual')
            .then((response) => {
               var cicloSplit = response.data.valor.split('-')
               if (cicloSplit[0] == 'I') {
                  this.cmbCiclo.push('II-' + (parseInt(cicloSplit[1]) - 1))
                  this.selectCiclo = 'II-' + (parseInt(cicloSplit[1]) - 1)
               } else {
                  this.cmbCiclo.push('I-' + cicloSplit[1])
                  this.selectCiclo = 'I-' + cicloSplit[1]
               }
            })
            .catch(() => {
               //console.log(error)
            })
      },
      getColorEstado(item) {
         if (
            this.toISOLocal(new Date()).substr(0, 10) >
               this.parseDate(item.fechaVencimiento) &&
            !item.facturado
         ) {
            return 'red'
         } else {
            if (item.facturado) {
               return 'green'
            } else {
               return 'blue'
            }
         }
      },
      getStatus(item) {
         if (
            this.toISOLocal(new Date()).substr(0, 10) >
            this.parseDate(item.fechaVencimiento)
         ) {
            return 'En mora'
         } else {
            return 'Pendiente'
         }
      },
      ajustarAltura() {
         const tableArea = this.$el && this.$el.querySelector('.record-table-area')
         const resumen = this.$el && this.$el.querySelector('.record-resumen-area')
         const searchBar = this.$el && this.$el.querySelector('.record-search-bar')
         if (!tableArea) return
         const searchH = searchBar ? searchBar.offsetHeight : 60
         const resumenH = resumen ? resumen.offsetHeight : 60
         const availH = window.innerHeight - 48 - searchH - resumenH
         tableArea.style.height = availH + 'px'
      },
      getProm(item) {
         let suma =
            Number(item.periodoA) +
            Number(item.periodoB) +
            Number(item.periodoC)
         if (suma > 0) {
            return (
               suma /
               (Number(item.numeroPeriodos) > 0
                  ? Number(item.numeroPeriodos)
                  : 1)
            ).toFixed(2)
         } else {
            return 0.0
         }
      }
   }
}
</script>

<style scoped>
.record-alu-fullscreen {
   display: flex;
   flex-direction: column;
   height: calc(100vh - 48px);
   overflow: hidden;
}

.record-search-bar {
   display: flex;
   align-items: center;
   gap: 16px;
   padding: 10px 20px;
   background: #fafafa;
   border-bottom: 1px solid #e0e0e0;
   flex-shrink: 0;
   height: 60px;
}

.record-table-area {
   flex: 1;
   min-height: 0;
   overflow: hidden;
   display: flex;
   flex-direction: column;
}

/* Fuerza al datatable a ocupar todo el espacio sin scroll externo */
.record-table-area .record-datatable {
   height: 100%;
   overflow: hidden;
}

.record-table-area .record-datatable >>> .v-data-table__wrapper {
   height: 100%;
   overflow: hidden !important;
}

.record-resumen-area {
   flex-shrink: 0;
   border-top: 2px solid #e0e0e0;
   background: #fafafa;
}
.resumen-row-clickable {
   cursor: pointer;
   transition: background 0.15s;
}
.resumen-row-clickable:hover { background: #fff3f3 !important; }
.resumen-dialog-card { border-radius: 12px !important; overflow: hidden; }
.resumen-dialog-title { font-size: 16px !important; font-weight: 700; padding: 14px 20px !important; }
.resumen-big-grid {
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 16px;
}
.resumen-big-stat {
   border-radius: 12px;
   padding: 20px 12px 16px;
   text-align: center;
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 6px;
}
.rbs-value {
   font-size: 52px;
   font-weight: 800;
   line-height: 1;
}
.rbs-label {
   font-size: 11px;
   font-weight: 600;
   text-transform: uppercase;
   letter-spacing: 0.8px;
   opacity: 0.75;
}
.resumen-stat--green  { background: #e8f5e9; color: #2e7d32; }
.resumen-stat--red    { background: #ffebee; color: #c62828; }
.resumen-stat--blue   { background: #e3f2fd; color: #1565c0; }
.resumen-stat--primary { background: #fce4ec; color: #880e4f; }
</style>
